// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "e9c31fef914cb7c1d0793767e4a2206d64a1aee7f4ced56802c60ea385113cb1" + ".css";
};